module.exports = __webpack_public_path__ + "static/logo-wc-heading-8d987dbab1704706cb9f90af77214247.png";